if (window.phoneValidationInitialized === undefined) {
  window.phoneValidationInitialized = true;

  let phoneValidationModule;

  // Cache the import promise, but drop it on failure so a later interaction can
  // retry (a rejected promise is truthy and would otherwise stick forever).
  const loadPhoneValidation = () => {
    if (!phoneValidationModule) {
      phoneValidationModule = import('../../../phone_validation').catch(
        error => {
          phoneValidationModule = undefined;
          if (window.Sentry) {
            window.Sentry.captureException(error);
          }
          throw error;
        },
      );
    }
    return phoneValidationModule;
  };

  const observer = new IntersectionObserver(async entries => {
    for (const entry of entries) {
      if (entry.isIntersecting) {
        try {
          (await loadPhoneValidation()).default();
        } catch {
          return;
        }

        for (const e of entries) {
          observer.unobserve(e.target);
        }
      }
    }
  });

  const phoneInputEls = document.querySelectorAll('.js-phone-input');
  phoneInputEls.forEach(element => observer.observe(element));

  // Evaluate the intl-tel-input chunk while the browser is idle so it is ready
  // before the first interaction, keeping its cost off the INP path.
  if (phoneInputEls.length > 0) {
    const prewarm = () => {
      loadPhoneValidation().catch(() => {});
    };
    if (typeof window.requestIdleCallback === 'function') {
      window.requestIdleCallback(prewarm);
    } else {
      setTimeout(prewarm, 0);
    }
  }
}
